import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { AVAILABILITY_TYPES } from '../../constants/availability.constants';
import { formatRecurringDays } from '../../formatting/dateFormatting';

// Enable timezone plugins
dayjs.extend(utc);
dayjs.extend(timezone);

// 🔄 TYPE OF AVAILABILITY ACCORDING TO FLAGS
export const getEventType = (recurring, fullDays) => {
  if (recurring && fullDays) return AVAILABILITY_TYPES.RECURRING_FULL_DAYS;
  if (recurring) return AVAILABILITY_TYPES.RECURRING;
  if (fullDays) return AVAILABILITY_TYPES.FULL_DAYS;
  return AVAILABILITY_TYPES.SINGLE_EVENT;
};

// 📆 TEXT READABLE OF THE EVENT ACCORDING TO ITS TYPE
export const getAvailabilityDescriptionText = (event, venueTimezone) => {
  const { type, startDate, endDate, startTimeDate, endTimeDate, days = [] } = event;

  // Convert dates to venue timezone for comparison
  // Recurring and single day events use startTimeDate and endTimeDate, full day events use startDate and endDate
  const startInVenue = dayjs.tz(startTimeDate || startDate, venueTimezone);
  const endInVenue = dayjs.tz(endTimeDate || endDate, venueTimezone);
  const isTheSameDay = startInVenue.isSame(endInVenue, 'day');

  switch (type) {
    case AVAILABILITY_TYPES.FULL_DAYS:
      return isTheSameDay
        ? `${startInVenue.format('MM/DD/YYYY')}, full day`
        : `${startInVenue.format('MM/DD/YYYY')} - ${endInVenue.format('MM/DD/YYYY')}, full days`;

    case AVAILABILITY_TYPES.RECURRING_FULL_DAYS: {
      const baseText = `Full days,`;
      const daysText = days.length ? ` ${formatRecurringDays(days)}` : '';
      return `${baseText}${daysText}`;
    }

    case AVAILABILITY_TYPES.RECURRING: {
      if (!startTimeDate || !endTimeDate) return '';
      const timeRange = `${startInVenue.format('h:mm A')} - ${endInVenue.format('h:mm A')}`;
      const recurringDays = formatRecurringDays(days);
      return `${timeRange}, ${recurringDays}`;
    }

    case AVAILABILITY_TYPES.SINGLE_EVENT:
      if (!startInVenue || !endInVenue) return '';
      return `${startInVenue.format('MM/DD/YYYY')}, ${startInVenue.format('h:mm A')} - ${endInVenue.format('h:mm A')}`;

    default:
      return;
  }
};
